import React from "react";

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useTheme,
} from "@mui/material";
import clsx from "clsx";
import mainStyles from "styles";

type SummaryDetail = Record<string, number>;

interface TemporalResultDetail {
  S3Bucket: string;
  S3FailedDocumentsKey: string;
  Summary: SummaryDetail | null;
  ErrorCount: number;
}

type TemporalResult = Record<string, TemporalResultDetail>;

export interface StageResults {
  TemporalResult: TemporalResult;
}

export interface MigrateOrganisationStageInfoTableProps {
  stageResults: StageResults;
}

export const MigrateOrganisationStageInfoTable: React.FC<
  MigrateOrganisationStageInfoTableProps
> = ({ stageResults: results }) => {
  const classes = mainStyles();
  const theme = useTheme();

  function renderTemporalResultRows(results: StageResults) {
    return Object.entries(results.TemporalResult).map(
      ([category, details], index) => (
        <TableRow
          key={index}
          data-testid={`migrate-org-stage-details-${category}`}
        >
          <TableCell
            className={clsx(
              classes.tableCell,
              classes.leftCell,
              classes.tableLeftColPadding,
            )}
            align="right"
            data-testid={`${category}-domain`}
          >
            {category}
          </TableCell>
          <TableCell
            className={clsx(classes.tableCell)}
            align="left"
            data-testid={`${category}-success-count`}
          >
            {details.Summary ? JSON.stringify(details.Summary[category]) : "0"}
          </TableCell>
          <TableCell
            className={clsx(
              classes.tableCell,
              classes.rightCell,
              classes.tableRightColPadding,
            )}
            align="left"
            data-testid={`${category}-error-count`}
          >
            {details.ErrorCount}
          </TableCell>
        </TableRow>
      ),
    );
  }
  return (
    <Box
      style={{
        borderColor: theme.palette.divider,
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: "5px",
        width: "100%",
      }}
    >
      <Table data-testid="table-copy-result">
        <TableHead>
          <TableCell
            className={clsx(
              classes.tableCell,
              classes.leftCell,
              classes.tableLeftColPadding,
            )}
            align="center"
          >
            Domains
          </TableCell>
          <TableCell
            className={clsx(classes.tableCell, classes.leftCell)}
            align="center"
          >
            Count
          </TableCell>
          <TableCell
            className={clsx(
              classes.tableCell,
              classes.rightCell,
              classes.tableRightColPadding,
            )}
            align="center"
          >
            Error
          </TableCell>
        </TableHead>
        <TableBody>{renderTemporalResultRows(results)}</TableBody>
      </Table>
    </Box>
  );
};
